import { observer } from "mobx-react";
import { Alert } from "@/components-v2/Alert";
import { VBox } from "@/components-v2/Box";
import { Autocomplete } from "@/components-v2/Autocomplete";
import { formatOrgNum } from "@/utils/other";
import { useTranslation } from "@/stores/RootStoreContext";
import { ChangeOfBusinessManagerForm } from "./changeOfBusinessManagerDomain";

const BusinessManagerAutocomplete = observer(function BusinessManagerAutocomplete({
  form,
}: {
  form: ChangeOfBusinessManagerForm;
}) {
  const { t } = useTranslation();
  return (
    <VBox>
      <Autocomplete
        label={t("decisions.changeOfBusinessManager.select")}
        disabled={form.isProjectLocked}
        items={form.suggestedCompanies}
        value={form.selectedCompany}
        idFn={(item) => item.organizationnumber}
        labelFn={(item) => item.name}
        inputValue={form.searchCompanyModel.inputValue}
        onInputValueChange={form.setCompanySearch}
        onSelect={form.setSelectedCompany}
        onClear={form.clearSelectedCompany}
      />
      {form.validationError && <Alert type={"error"} message={<>{t(form.validationError)}</>} />}
    </VBox>
  );
});

export const ChangeOfBusinessManagerView = observer(function ChangeOfBusinessManagerView({
  form,
}: {
  form: ChangeOfBusinessManagerForm;
}) {
  const { t } = useTranslation();
  const orgNoPrefix = t("decisions.changeOfBusinessManager.orgNoPrefix");

  return (
    <VBox gap={"md"}>
      {form.currentBusinessManager ? (
        <div>
          <div>{t("decisions.changeOfBusinessManager.company-business-manager-now")}</div>
          {`${form.currentBusinessManager.name} (${orgNoPrefix} ${formatOrgNum(
            form.currentBusinessManager.organisationNumber,
          )})`}
        </div>
      ) : (
        <div>
          <div>{t("decisions.changeOfBusinessManager.company-no-business-manager")}</div>
        </div>
      )}
      <BusinessManagerAutocomplete form={form} />
      {form.selectedCompany && (
        <VBox gap="md">
          <div>
            <div>{t("decisions.changeOfBusinessManager.company-business-manager-willbe")}</div>
            <strong>{form.selectedCompany.name}</strong>
            {` (${orgNoPrefix} ${formatOrgNum(form.selectedCompany.organizationnumber)})`}
          </div>
        </VBox>
      )}
    </VBox>
  );
});
